import styled from "styled-components";
import { rem } from "./styles";

export const AuthorizedPageWrapper = styled.div`
  padding-bottom: ${rem(87)};
`;
